import { RouterPath } from '../../router-path';
export var identityAppPath = {
  authentication: RouterPath.create('/authentication'),
  resetPassword: RouterPath.create('/reset-password'),
  requestEmail: RouterPath.create('/request-email'),
  emailConfirmation: RouterPath.create('/confirmation'),
  signOut: RouterPath.create('/logout'),
  googleCallback: RouterPath.create('/google-callback'),
  accountSetting: {
    updateProfile: RouterPath.create('/account-setting/update-profile'),
    missingProfile: RouterPath.create('/account-setting/missing-profile'),
    changePassword: RouterPath.create('/account-setting/change-password'),
    usage: RouterPath.create('/account-setting/usage'),
    plan: RouterPath.create('/account-setting/plan')
  }
};